export default {"src":"/_next/static/media/hatchback.04c05102.svg","height":150,"width":251,"blurWidth":0,"blurHeight":0};